export default class ProductApi {
    static findProductByCode(code){
        return fetch(`/api/product/${code}`,{
            method: 'GET',
            headers:new Headers( {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        })
        .then(res => res.json())
        .then(
        (result) => {
            return result
        },
        (error) => {
            return error
        }
        )
    }
}